.page {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  position: relative;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #ffffff;
}

.subtitle {
  margin: 4px 0 0;
  color: #ffffff;
  font-size: 13px;
}

.controls {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
}

.modeToggle {
  display: inline-flex;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  overflow: hidden;
}

.toggle,
.toggleActive {
  background: rgba(255, 255, 255, 0.15);
  color: #ffffff;
  border: none;
  padding: 6px 12px;
  font-size: 13px;
  cursor: pointer;
}

.toggleActive {
  background: #ffffff;
  color: #0c0c0c;
}

.select {
  background: #ffffff;
  color: #0c0c0c;
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 13px;
  min-width: 220px;
  appearance: none;
  -webkit-appearance: none;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'><path d='M2 4 L6 8 L10 4' fill='none' stroke='%230c0c0c' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/></svg>");
  background-repeat: no-repeat;
  background-position: right 10px center;
  padding-right: 28px;
  cursor: pointer;
}

.select:focus {
  outline: 2px solid #ffffff;
  outline-offset: 1px;
}

.select option {
  background: #ffffff;
  color: #0c0c0c;
}

.multiPicker {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-width: 60%;
}

.checkLabel {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 12px;
  color: #0c0c0c;
  cursor: pointer;
}

.totals {
  margin-left: auto;
  display: flex;
  gap: 16px;
  font-size: 13px;
  color: #ffffff;
}

.totals span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.dotBillable,
.dotNonBillable {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.dotBillable {
  background: #a084e8;
}

.dotNonBillable {
  background: #8c8ca0;
}

.calendarWrap {
  flex: 1;
  min-height: 700px;
}

.error {
  background: rgba(255, 77, 109, 0.1);
  color: #ff4d6d;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 13px;
}

.loading {
  color: #ffffff;
  font-size: 13px;
}

.popover {
  position: absolute;
  background: #ffffff;
  border: 1px solid #e2e2e6;
  border-radius: 8px;
  padding: 14px;
  min-width: 300px;
  max-width: 380px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.18);
  z-index: 100;
  font-size: 12px;
  color: #0c0c0c;
}

.popoverTitle {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 8px;
  color: #0c0c0c;
}

.popoverRow {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 4px 0;
  color: #0c0c0c;
}

.popoverLabel {
  color: #6b6b76;
  font-weight: 500;
}

.popoverActions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #e2e2e6;
}

.popoverButton {
  flex: 1;
  text-align: center;
  background: #6e68cc;
  color: #ffffff;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.15s ease;
}

.popoverButton:hover {
  background: #5b56b3;
}
